import { initializeApollo } from 'gql/client'
import { NextWrapper } from 'data-fetching-wrapper'
import { CategoriaNode, SottocategoriaVolantinoDocument } from '@gql/graphql'

import SottoCategoriaVolantiniTemplate from '@components/templates/SottoCategoriaVolantiniTemplate/SottoCategoriaVolantiniTemplate'

const SottocategoriaVolantino = ({ sottocategoria }: { sottocategoria: CategoriaNode }) => {
  return <SottoCategoriaVolantiniTemplate sottoCategoria={sottocategoria} />
}

export const getStaticPaths = NextWrapper.getStaticPaths(
  async () => ({
    paths: [],
    fallback: 'blocking',
  }),
  '/volantini-digitali/[categoriaSlug]/[slug]'
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ params: { categoriaSlug, slug }, preview, previewData, locale }) => {
    const client = initializeApollo(locale)
    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { sottocategoriaVolantino },
    } = await client.query({
      query: SottocategoriaVolantinoDocument,
      variables: { slugVolantino: categoriaSlug, slug: slug, preview },
      context: {
        headers,
      },
    })

    if (!sottocategoriaVolantino) {
      return {
        notFound: true,
      }
    }

    return {
      props: {
        sottocategoria: sottocategoriaVolantino,
      },
      revalidate: 60 * 20,
    }
  },
  '/volantini-digitali/[categoriaSlug]/[slug]'
)

export default SottocategoriaVolantino
